/**
 * TBID SSO submodule --
 * If enabled, polls TBID XAUTH servlet to detect user login status
 * and sends user through appropriate log in/out flow
 */
import {
    checkSalesforceDomain,
    fetchTBIDInfo,
    getIISLoggedInCookie,
    getTbidSessionStorage,
    getUserProfile,
    removeTbidSessionStorage,
} from './utils';

let POLL_FREQ = 5000; // how often to check for user login status
const shouldReload = () => {
    return !location.pathname.endsWith('/trailblazer/complete-signup');
};

// eslint-disable-next-line complexity
const checkAlive = async (): Promise<void> => {
    if (!shouldReload()) {
        return;
    }
    const cookiePresent = getIISLoggedInCookie();
    const storagePresent = !!getTbidSessionStorage();
    const reloadOnSSOAuthEvent = (window as any).sfdcBase.formModal || undefined;

    if (cookiePresent && !storagePresent) {
        // logged in
        const userInfo = await getUserProfile();
        if (userInfo === undefined) {
            backOffPolling();
        }
        // Reload the page if model(reloadOnSSOAuthEvent provides signal) is not opened and userInfo is available
        if (userInfo && !reloadOnSSOAuthEvent) {
            // reset poll frequency on success
            resetPolling();
            location.reload();
        }
    }

    const onSalesforceDomain = checkSalesforceDomain();

    if (!cookiePresent && storagePresent) {
        if (onSalesforceDomain && !reloadOnSSOAuthEvent) {
            removeTbidSessionStorage();
            location.reload();
        } else {
            const info = await fetchTBIDInfo();
            if (!info && !reloadOnSSOAuthEvent) {
                removeTbidSessionStorage();
                location.reload();
            }
        }
    }

    if (!cookiePresent && !storagePresent) {
        if (!onSalesforceDomain) {
            const userInfo = await getUserProfile().catch(() => {
                // preventing error from going uncaught but keeping original functionality of returning undefined
                return undefined;
            });

            if (userInfo && !reloadOnSSOAuthEvent) {
                location.reload();
            }
        }
    }
};

/**
 * Initialize SSO functionality if enabled
 */
export const initSso = async (): Promise<void> => {
    setInterval(checkAlive, POLL_FREQ);
};

export const resetPolling = () => {
    POLL_FREQ = 5000;
};

// end interval in case of network error
export const backOffPolling = () => {
    POLL_FREQ = POLL_FREQ * 2;
};

// for testing only.
export const testable = {
    checkAlive,
};
